import React, { useState, useEffect } from "react";
import Swal from "sweetalert2";
import { Container, Nav } from "react-bootstrap";
import "bootstrap-icons/font/bootstrap-icons.css";

import Header_Company from "../../Components/Header_Company";
import Register_Agent from "../../Components/CompanyDetails/Register_Agent";
import Register_Supervisor from "../../Components/CompanyDetails/Register_Supervisor";
import "./Company.css";

const Register_Company_Emp = () => {
  const [activeTab, setActiveTab] = useState("supervisor");

  useEffect(() => {
    const storedUserData = sessionStorage.getItem("user");
    if (!storedUserData) {
      Swal.fire("Error", "Your session has expired. Please sign in again.", "error");
    }
  }, []);

  return (
    <div className="co-page">
      <Header_Company />

      <Container fluid="xl">
        <div className="co-hero">
          <h2>
            <i className="bi bi-person-plus me-2" />
            Register Team
          </h2>
          <p>Create supervisors and agents for your company.</p>
        </div>

        <Nav variant="pills" className="co-step-nav gap-2 mb-3 flex-nowrap">
          <Nav.Item>
            <Nav.Link
              active={activeTab === "supervisor"}
              onClick={() => setActiveTab("supervisor")}
            >
              <i className="bi bi-person-badge me-1" />
              Register Supervisor
            </Nav.Link>
          </Nav.Item>
          <Nav.Item>
            <Nav.Link
              active={activeTab === "agent"}
              onClick={() => setActiveTab("agent")}
            >
              <i className="bi bi-person-vcard me-1" />
              Register Agent
            </Nav.Link>
          </Nav.Item>
        </Nav>

        {activeTab === "supervisor" && (
          <div className="card co-card p-3 p-md-4">
            <Register_Supervisor embedded />
          </div>
        )}
        {activeTab === "agent" && (
          <div className="card co-card p-3 p-md-4">
            <Register_Agent embedded />
          </div>
        )}
      </Container>
    </div>
  );
};

export default Register_Company_Emp;
